// src/pages/AgentsPage.jsx
import React from 'react'
import { FiUser, FiPhone, FiMail } from 'react-icons/fi'
import Footer from '../components/Footer'

export default function AgentsPage() {
  // dummy data for design preview
  const agents = [
    {
      id: 1,
      name: 'Auto',
      phone: '+971 50 123 4567',
      email: 'import@delemon.local',
      avatar: null,
    },
    {
      id: 2,
      name: 'Sara Ahmed',
      phone: '+971 50 765 4321',
      email: 'sara@justoffplan.ai',
      avatar: null,
    },
    {
      id: 3,
      name: 'Omar Khalid',
      phone: '+971 52 111 2233',
      email: 'omar@justoffplan.ai',
      avatar: null,
    },

  ]

  return (
    <>
    <section className="py-20 bg-gray-50">
      {/* Section header */}
      <div className="max-w-7xl mx-auto px-4 flex items-center mb-12">
        <FiUser className="text-emerald-400 text-3xl mr-3" />
        <h2 className="text-3xl font-bold text-gray-900">Our Agents</h2>
      </div>

      {/* Cards grid */}
      <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
        {agents.map((agent) => (
          <div
            key={agent.id}
            className="bg-white rounded-2xl shadow-lg overflow-hidden"
          >
            {/* Avatar placeholder */}
            <div className="flex items-center justify-center h-40 bg-gray-100">
              {agent.avatar ? (
                <img
                  src={agent.avatar}
                  alt={agent.name}
                  className="h-24 w-24 rounded-full object-cover"
                />
              ) : (
                <FiUser className="text-gray-400 text-6xl" />
              )}
            </div>

            <div className="p-6">
              {/* Agent name */}
              <h3 className="text-xl font-semibold text-gray-800 mb-4 text-center">
                {agent.name}
              </h3>

              {/* Contact info */}
              <div className="space-y-3 text-gray-600">
                <div className="flex items-center">
                  <FiPhone className="mr-2 text-gray-400" />
                  <span>{agent.phone}</span>
                </div>
                <div className="flex items-center">
                  <FiMail className="mr-2 text-gray-400" />
                  <span>{agent.email}</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
   
    </section>
     <Footer />
     </>
  )
}
